<app-header [isMobile]="isMobile"></app-header>

<div class="wrapper">
    <div class="top" [ngStyle]="{backgroundImage: 'url('+ (!isMobile ?data.bg : data.bgMobile) +')'}">
        <!-- <div class="top" [ngStyle]="{backgroundImage: 'url('+ data.bgMobile +')'}"> -->
        <div class="backButton">
            <a routerLink="/">
                <img src="assets/img/back-button2.png" class="back" alt="">
                <img src="assets/img/back-button2-rollover.png" class="backOver" alt="">
            </a>
        </div>
        <div class="mobileLine" *ngIf="isMobile"></div>
        <div [class]=" 'logo ' + data.id ">
            <img [src]="data.logo" alt="">
        </div>
        <div class="quote" [class]="data.id" *ngIf="!isMobile" [innerHTML]="data.quote | safeHtml" [ngStyle]="{color: data.descriptionColor}">
        </div>
        <div class="quote mobile" [class]="data.id" [ngClass]="{large: !data.isChannelPreviewOn}" *ngIf="isMobile" [innerHTML]="data.quoteMobile | safeHtml" [ngStyle]="{color: data.descriptionColor}">
        </div>

        <div class="dropdownButtons">

            <div class="dropdownButton" (click)="onWhereToWatch()" (mouseenter)="dropdownButtonOver($event)"
                (mouseleave)="dropdownButtonOut($event)">
                <div class="label">Where To Watch</div>
                <div class="arrow"></div>
            </div>


            <div *ngIf="data.isChannelPreviewOn" class="dropdownButton"  (click)="onOpenSizzleOverlay(data.path)"
                (mouseenter)="dropdownButtonOver($event)" (mouseleave)="dropdownButtonOut($event)">
                <div class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
                        width="256" height="256" viewBox="0 0 256 256" xml:space="preserve">

                        <defs>
                        </defs>
                        <g style="stroke: none; stroke-width: 0; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; fill: none; fill-rule: nonzero; opacity: 1;"
                            transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
                            <path [ngStyle]="{fill: '#fff'}"
                                d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 10 c -19.299 0 -35 15.701 -35 35 s 15.701 35 35 35 s 35 -15.701 35 -35 S 64.299 10 45 10 z"
                                style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;  fill-rule: nonzero; opacity: 1;"
                                transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                            <path [ngStyle]="{fill: '#fff'}"
                                d="M 61.806 47.026 c 1.559 -0.9 1.559 -3.151 0 -4.051 l -12.91 -7.453 l -12.91 -7.453 c -1.559 -0.9 -3.509 0.225 -3.509 2.026 V 45 v 14.907 c 0 1.801 1.949 2.926 3.509 2.026 l 12.91 -7.453 L 61.806 47.026 z"
                                style="stroke: none; stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10;  fill-rule: nonzero; opacity: 1;"
                                transform=" matrix(1 0 0 1 0 0) " stroke-linecap="round" />
                        </g>
                    </svg>
                </div>
                <div class="label" [innerHTML]="pageData.data[0].sizzleVideoLabel | safeHtml"></div>
                <div class="arrow"></div>
            </div>

        </div>
        <div class="socialLinks">
            <!-- <div class="youtubeLink socLink" *ngIf="data.youtube && data.youtube != ''">
                <a [href]="data.youtube" target="_blank">
                    <div class="logoButton">
                        <img src="assets/img/youtube-v2.png" alt="">
                    </div>
                </a>
            </div> -->

            <div class="instagramLink socLink" *ngIf="data.instagram && data.instagram != ''">
                <a [href]="data.instagram" target="_blank">
                    <div class="logoButton">
                        <img src="assets/img/instagram.png" alt="">
                    </div>
                </a>
            </div>

            <div class="xLink socLink" *ngIf="data.x && data.x != ''">
                <a [href]="data.x" target="_blank">
                    <div class="logoButton">
                        <img src="assets/img/x.png" alt="">
                    </div>
                </a>
            </div>
            
            <div class="fbLink socLink" *ngIf="data.facebook && data.facebook != ''">
                <a [href]="data.facebook" target="_blank">
                    <div class="logoButton">
                        <img src="assets/img/facebook.png" alt="">
                    </div>
                </a>
            </div>
        </div>
    </div>

    <div class="whereToWatchList">
        <div class="whereToWatchListHolder">

            <div class="titleHolder">
                <div class="title">
                    {{data.title}} is available on the following streaming platforms:
                </div>
                <div class="closeBtn">
                    <app-close-button (click)="onWhereToWatchClose()"></app-close-button>
                </div>

            </div>
            <div class="listWrapper">
                <!-- <a [href]="item.link" target="_blank" *ngFor="let item of data.whereToWatch"> -->
                <a [href]="item.link" target="_blank" *ngFor="let item of pageData.get(data.path)?.whereToWatch"
                    [ngClass]="{disabled: item.link == ''}">
                    <img [src]="item.logo" alt="">
                </a>
            </div>
        </div>
    </div>
    <div class="feaured">
        <!-- <div class="featuredTitle">
            Featured Streaming Films -{{today | date: 'MMMM yyyy'}}
        </div> -->


        <div class="placeholder">
            <app-poster-card *ngFor="let item of apiService.posterList" [show]="item" [color1]="data.calendarColor1"
                [color2]="data.calendarColor2" [color3]="data.calendarColor3" [color4]="data.calendarColor4" [channel]="data.title"></app-poster-card>
        </div>
    </div>

    <div class="dateList">
        <app-day-buttons-list [color1]="data.color1" [color2]="data.color2" [color3]="data.color3"
            [color4]="data.color4"></app-day-buttons-list>
    </div>

    <div class="selectionView" *ngIf="apiService.daySelected">

        <div class="selectedDay">
            <!-- {{ apiService.daySelected?.date?.toDate() | date: 'EEEE: MMMM dd, YYYY' }} -->
        </div>

        <div class="programs">
            <app-program-card [show]="item" [color1]="this.data.calendarColor1" [color2]="this.data.calendarColor2" [channel]="this.data.title"
                [color3]="this.data.calendarColor3" [color4]="this.data.calendarColor4"
                *ngFor="let item of apiService.daySelected?.list; let i = index;" [isActive]="i == 0"
                [isNext]="i == 1"></app-program-card>
        </div>
    </div>
</div>

<app-footer [isInverted]="true"></app-footer>

<div class="sizzleBg" [ngClass]="{open: pageData.isOverlayOpen}"></div>
<app-sizzle-overlay></app-sizzle-overlay>
